/**
 * TGCP Schema Fix — merges Air Reviews' aggregateRating into Dawn's
 * main Product/ProductGroup JSON-LD block so Google sees ONE consistent
 * schema instead of two disconnected ones.
 *
 * Works automatically on every product page, for every current and
 * future product. No per-product setup needed.
 *
 * IMPORTANT: This file must stay linked in theme.liquid. Custom asset
 * files like this one survive theme updates on their own, but the
 * <script> tag that loads it in theme.liquid can get wiped during a
 * major theme update — same as tgcp-custom.css and the age-verification
 * section. Re-check after every major Dawn update.
 */
(function () {
  function mergeAggregateRating() {
    var scripts = document.querySelectorAll('script[type="application/ld+json"]');
    var mainSchemaEl = null;
    var mainSchemaData = null;
    var ratingData = null;

    scripts.forEach(function (el) {
      var data;
      try {
        data = JSON.parse(el.textContent);
      } catch (e) {
        return;
      }

      // Dawn's main product schema: either "Product" or "ProductGroup"
      // (ProductGroup when the product has variants, like your
      // memberships and multi-tier products).
      if (
        (data['@type'] === 'ProductGroup' || data['@type'] === 'Product') &&
        !mainSchemaData
      ) {
        // Skip the Air Reviews block itself — it has no hasVariant/offers
        // and no @id pointing to the product URL fragment.
        var looksLikeAirReviewsBlock =
          data.aggregateRating && !data.hasVariant && !data.offers && !data['@id'];

        if (!looksLikeAirReviewsBlock) {
          mainSchemaData = data;
          mainSchemaEl = el;
        }
      }

      // Air Reviews' separate block: has aggregateRating but is not
      // the main product entity.
      if (data.aggregateRating && (!data.hasVariant && !data.offers)) {
        ratingData = data.aggregateRating;
      }
    });

    if (mainSchemaEl && mainSchemaData && ratingData && !mainSchemaData.aggregateRating) {
      mainSchemaData.aggregateRating = ratingData;
      mainSchemaEl.textContent = JSON.stringify(mainSchemaData);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mergeAggregateRating);
  } else {
    mergeAggregateRating();
  }
})();
